module.exports = __webpack_public_path__ + "static/media/cosmosbanner_sm1.553f14e7.png";